/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_UserDefinedFieldsListDto } from '../models/PagedResultDto_UserDefinedFieldsListDto';
import type { Wealthlane_CustomerService_Dtos_UserDefinedFields_UpdateUserDefinedFieldsDto } from '../models/Wealthlane_CustomerService_Dtos_UserDefinedFields_UpdateUserDefinedFieldsDto';
import type { Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedFieldsDto } from '../models/Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedFieldsDto';
import type { Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedFieldsGetDto } from '../models/Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedFieldsGetDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserDefinedFieldsService {

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedFieldsDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppUserDefinedFieldsUserDefinedFields(
requestBody?: Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedFieldsDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedFieldsDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/user-defined-fields/user-defined-fields',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedFieldsGetDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppUserDefinedFieldsUserDefinedFieldById(
id: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedFieldsGetDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/user-defined-fields/user-defined-field-by-id/{Id}',
            path: {
                'Id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_UserDefinedFields_UpdateUserDefinedFieldsDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppUserDefinedFieldsUserDefinedField(
requestBody?: Wealthlane_CustomerService_Dtos_UserDefinedFields_UpdateUserDefinedFieldsDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_UserDefinedFields_UpdateUserDefinedFieldsDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/user-defined-fields/user-defined-field',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param moduleId 
     * @param statusId 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_UserDefinedFieldsListDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppUserDefinedFieldsUserDefinedFieldsList(
moduleId?: number,
statusId?: number,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_UserDefinedFieldsListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/user-defined-fields/user-defined-fields-list',
            query: {
                'ModuleId': moduleId,
                'StatusId': statusId,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns boolean OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiAppUserDefinedFields(
id?: string,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/app/user-defined-fields',
            query: {
                'Id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param moduleIds 
     * @param statusId 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_UserDefinedFieldsListDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppUserDefinedFieldsUserDefinedFieldsWithMultipleFilterList(
moduleIds?: Array<number>,
statusId?: number,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_UserDefinedFieldsListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/user-defined-fields/user-defined-fields-with-multiple-filter-list',
            query: {
                'ModuleIds': moduleIds,
                'StatusId': statusId,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
